import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const EditDZ = (props) => {
  const [value, setValue] = useState(props.client.data_zasw);
  const [loading, setLoading] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [freeDays, setFreeDays] = useState([]);

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  useEffect(() => {
    setLoading(true);
    fetchHolidays();
  }, []);

  const addDay = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 49));
    return retDate;
  };

  const getActualSygnForClient = () => {
    var sygns = props.sygnForClient.filter(
      (el) => +el.clientId === +props.client.id
    );
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn.length > 4
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const getActualCourtForClient = () => {
    var sygns = props.sygnForClient.filter(
      (el) => +el.clientId === +props.client.id
    );
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].court !== ""
        ? sygns[0].court
        : "brak danych"
      : "brak danych";
  };

  const getLawyerName = (initials) => {
    var name = props.users.filter((el) => el.initials === initials);
    return name.length > 0 ? name[0].name : "brak danych";
  };

  const addDayOne = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    return retDate;
  };

  const addDaySeven = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 7));
    return retDate;
  };

  const editClientAddT = async () => {
    if (validatePayment()) {
      setLoading(true);

      var model = [];

      if (props.team === 0) {
        props.lawyersData.map((element) => {
          model[element.name] = element.name;
        });
      } else {
        props.lawyersData
          .filter((el) => el.team.includes(props.team))
          .map((element) => {
            model[element.name] = element.name;
          });
      }

      MySwal.fire({
        title: "Kto ma sporządzić wezwanie do zapłaty?",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(async function (result) {
        if (result.isConfirmed) {
          var resp = result.value;

          var date_startA =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate();

          var newFinalDate = addDaySeven(new Date());
          if (newFinalDate.getDay() === 0) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 1)
            );
          }
          if (newFinalDate.getDay() === 6) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 2)
            );
          }

          var date_final = newFinalDate;

          while (
            (checkFree(date_final) || checkHoliday(resp, date_final)) &&
            (date_final.getDay() === 0 || date_final.getDay() === 6)
          ) {
            date_final = addDayOne(date_final);
          }

          var dateFinal =
            date_final.getFullYear() +
            "-" +
            (date_final.getMonth() + 1) +
            "-" +
            date_final.getDate();

          var body3 = {
            start_date: date_startA,
            final_date: dateFinal,
            bank: props.client.bank,
            sygn: getActualSygnForClient(),
            responsible: resp,
            client_name: props.client.petitioner,
            task: "Wezwanie do zapłaty",
            date_added: date_added3,
            user_added: "",
            status: "ZLECONE",
            court: getActualCourtForClient(),
            type: "POZASĄDOWE",
            readed: "no",
            clientId: props.client.id,
            task_conn: "c",
            team: props.client.team,
          };

          fetch("https://apidevkppp.ftpeople.pl/insertTask", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body3),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});

          var body = {
            id: props.client.id,
            data_zasw: value,
            resp: resp,
          };

          fetch("https://apidevkppp.ftpeople.pl/addDZClient", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.text())
            .then(async (data) => {})
            .catch((error) => {});

          var date_added3 =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate() +
            " " +
            new Date().getHours() +
            ":" +
            new Date().getMinutes();
          var date_start3 =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate();
          var dateFinal3 = new Date();
          if (addDay(new Date(value)) < new Date()) {
            var newFinalDate3 = new Date(
              new Date().setDate(new Date().getDate() + 1)
            );
          } else {
            var newFinalDate3 = addDay(new Date(value));
          }
          if (newFinalDate3.getDay() === 0) {
            newFinalDate3 = new Date(
              newFinalDate3.setDate(newFinalDate3.getDate() + 1)
            );
          }
          if (newFinalDate3.getDay() === 6) {
            newFinalDate3 = new Date(
              newFinalDate3.setDate(newFinalDate3.getDate() + 2)
            );
          }

          while (
            (checkFree(newFinalDate3) ||
              checkHoliday(
                getLawyerName(props.client.client_owner),
                newFinalDate3
              )) &&
            (newFinalDate3.getDay() === 0 || newFinalDate3.getDay() === 6)
          ) {
            newFinalDate3 = addDayOne(newFinalDate3);
          }

          dateFinal3 =
            newFinalDate3.getFullYear() +
            "-" +
            (newFinalDate3.getMonth() + 1) +
            "-" +
            newFinalDate3.getDate();

          var body2 = {
            start_date: date_start3,
            final_date: dateFinal3,
            bank: props.client.bank,
            sygn: getActualSygnForClient(),
            responsible: getLawyerName(props.client.client_owner),
            client_name: props.client.petitioner,
            task: "Za 7 dni upływa terminu do wysłania pozwu",
            date_added: date_added3,
            user_added: "",
            status: "ZLECONE",
            court: getActualCourtForClient(),
            type: "POZASĄDOWE",
            readed: "no",
            clientId: props.client.id,
            task_conn: "c",
            team: props.client.team,
          };

          await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});

          props.logClientAction(
            "Edytowano datę otrzymania zaświadczenia od klienta",
            props.client.id
          );

          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "sprawę",
          }).then(async (result) => {
            props.close();
          });
        } else {
          props.close();
        }
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const editClientNAddT = async () => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        id: props.client.id,
        data_zasw: value,
      };

      fetch("https://apidevkppp.ftpeople.pl/addDZClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {})
        .catch((error) => {});

      var date_added3 =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes();
      var date_start3 =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate();
      var dateFinal3 = new Date();
      if (addDay(new Date(value)) < new Date()) {
        var newFinalDate3 = new Date(
          new Date().setDate(new Date().getDate() + 1)
        );
      } else {
        var newFinalDate3 = addDay(new Date(value));
      }
      if (newFinalDate3.getDay() === 0) {
        newFinalDate3 = new Date(
          newFinalDate3.setDate(newFinalDate3.getDate() + 1)
        );
      }
      if (newFinalDate3.getDay() === 6) {
        newFinalDate3 = new Date(
          newFinalDate3.setDate(newFinalDate3.getDate() + 2)
        );
      }

      while (
        (checkFree(newFinalDate3) ||
          checkHoliday(
            getLawyerName(props.client.client_owner),
            newFinalDate3
          )) &&
        (newFinalDate3.getDay() === 0 || newFinalDate3.getDay() === 6)
      ) {
        newFinalDate3 = addDayOne(newFinalDate3);
      }

      dateFinal3 =
        newFinalDate3.getFullYear() +
        "-" +
        (newFinalDate3.getMonth() + 1) +
        "-" +
        newFinalDate3.getDate();

      var body2 = {
        start_date: date_start3,
        final_date: dateFinal3,
        bank: props.client.bank,
        sygn: getActualSygnForClient(),
        responsible: getLawyerName(props.client.client_owner),
        client_name: props.client.petitioner,
        task: "Za 7 dni upływa terminu do wysłania pozwu",
        date_added: date_added3,
        user_added: "",
        status: "ZLECONE",
        court: getActualCourtForClient(),
        type: "POZASĄDOWE",
        readed: "no",
        clientId: props.client.id,
        task_conn: "c",
        team: props.team,
      };

      await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body2),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano datę otrzymania zaświadczenia od klienta",
        props.client.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "sprawę",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const editClient = async (e) => {
    var check = props.tasks.filter(
      (el) => el.task === "Wezwanie do zapłaty"
    ).length;
    if (check > 0) {
      editClientNAddT();
    } else {
      editClientAddT();
    }
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= final_date && el.date_from <= final_date) ||
          (final_date >= el.date_from && final_date <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="sepAddC">Informacje do pozwu</div>

          <div className="inputBox">
            <div className="inputCol_3">
              <label>
                Data otrzymania zaświadczenia od klienta{" "}
                <span className="requiredStar">*</span>
              </label>
              <input
                type="date"
                id="name"
                name="name"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditDZ;
